import { Component } from '@theme/component'
import { morph } from '@theme/morph'
import { ThemeEvents, VariantUpdateEvent } from '@theme/events'

class PickupAvailability extends Component {
  /** @type {AbortController | undefined} */
  #activeFetch

  connectedCallback() {
    super.connectedCallback()

    const closestSection = this.closest('.shopify-section, dialog')

    /** @type {(event: VariantUpdateEvent) => void} */
    const variantUpdated = (event) => {
      if (!event.detail) return

      if (event.detail.data?.newProduct) {
        this.dataset.productUrl = event.detail.data.newProduct.url
      }

      const variantId = event.detail.resource ? event.detail.resource.id : null
      if (!variantId) return

      const currentVariantId = this.dataset.variantId || null

      if (variantId !== currentVariantId) {
        this.dataset.variantId = String(variantId)
        this.#fetchAvailability(String(variantId))
      }
    }

    closestSection?.addEventListener(ThemeEvents.variantUpdate, variantUpdated)

    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(
        ThemeEvents.variantUpdate,
        variantUpdated
      )
    }
  }

  #createAbortController() {
    if (this.#activeFetch) this.#activeFetch.abort()
    this.#activeFetch = new AbortController()
    return this.#activeFetch
  }

  /**
   * Fetches the updated pickup availability markup for a variant
   * and morphs this element with the fresh HTML.
   * @param {string} variantId
   */
  #fetchAvailability(variantId) {
    if (!variantId) return

    const abortController = this.#createAbortController()

    const url = this.dataset.productUrl
    const sectionId = this.dataset.sectionId

    if (!url || !sectionId) return

    fetch(`${url}?variant=${variantId}&section_id=${sectionId}`, {
      signal: abortController.signal
    })
      .then((response) => response.text())
      .then((text) => {
        if (abortController.signal.aborted) return

        const html = new DOMParser().parseFromString(text, 'text/html')
        const selector = `pickup-availability[data-variant-id="${variantId}"]`
        const wrapper = html.querySelector(selector)

        if (wrapper) {
          morph(this, wrapper)
        }
      })
      .catch((_e) => {
        if (abortController.signal.aborted) return
        // On error, keep existing content; no-op.
      })
  }
}

if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', PickupAvailability)
}
